/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckSquareCutIcon20Light = forwardRef('CheckSquareCutIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3 5.5A2.5 2.5 0 0 1 5.5 3H12a.5.5 0 0 0 0-1H5.5A3.5 3.5 0 0 0 2 5.5v8A3.5 3.5 0 0 0 5.5 17h8a3.5 3.5 0 0 0 3.5-3.5V10a.5.5 0 0 0-1 0v3.5a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 3 13.5v-8Z" }),
        React.createElement("path", { d: "M16.83 4.658a.5.5 0 1 0-.707-.707l-6.372 6.372a.984.984 0 0 1-1.392 0L5.994 7.96a.5.5 0 1 0-.707.707l2.365 2.364a1.984 1.984 0 0 0 2.806 0l6.372-6.372Z" })));
});
